import { apiRequest } from './client'

export interface ResendVerificationResponse {
  status: 'sent' | 'already_verified'
}

/** `POST /api/my/resend-verification` — ask Auth0 to re-send my verification email. */
export function resendMyVerification(token: string) {
  return apiRequest<ResendVerificationResponse>('/api/my/resend-verification', {
    method: 'POST',
    token,
  })
}
